module.exports = __webpack_public_path__ + "img/00026.0b9e04de.webp";